import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import clsx from "clsx"
import HomePageWrapper from "../Common/PageWrappers/HomePageWrapper"
import { useLazyLoadSelector } from "../../util/redux"
import { fetchDevice } from "../../actions/deviceActions"
import { fetchApprovedDeviceVersions, fetchUserOTAMessages } from "../../actions/otaActions"
import OTATable from "../OTAMessages/otaTable"
import { useSelector } from "react-redux"
import { fetchUserAlgReleases } from "../../actions/deviceUpdateActions"

const styles = (theme) => ({
  devicesCard: {
    width: "20vw",
  },
  toolbar: theme.mixins.toolbar,
  root: {},
  details: {
    display: "flex",
  },
  cardColor: {
    background: "linear-gradient(60deg, #0093C5, #1195C9)",
    color: "white",
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
  },
  locationText: {
    paddingLeft: "15px",
  },
  buttonProperty: {
    position: "absolute",
    top: "50%",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  uploadButton: {
    marginLeft: "8px",
    margin: theme.spacing(1),
  },
  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },
  submitButton: {
    marginTop: "10px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableContainers: {
    gap: "2em",
    flexWrap: "wrap-reverse",
  },
  button: {
    "&:focus": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
    "&:hover": {
      color: "white",
      backgroundColor: "#0A94C7",
    },
  },
})

const OTAMessages = (props) => {
  const { classes, ...rest } = props

  useLazyLoadSelector((state) => state.ota.messages, fetchUserOTAMessages, [], false)
  useLazyLoadSelector((state) => state.ota.deviceVersions, fetchApprovedDeviceVersions, [], false)
  useLazyLoadSelector((state) => state.device.deviceData, fetchDevice, [], false)
  useLazyLoadSelector((state) => state.deviceUpdates.allReleases, fetchUserAlgReleases, [], false)
  const loadingMessages = useSelector((state) => state.ota.loadingMessages)
  const loadingDevices = useSelector((state) => state.device.loadingDevices)

  return (
    <HomePageWrapper loading={!!loadingMessages || !!loadingDevices}>
      <div>
        <div className={[classes.contentPadding, classes.sectionHeader].join(" ")}>
          <h1>Over-the-Air Messages</h1>
        </div>
        <br />
        <OTATable {...rest} className={clsx(classes.root, classes)} tableHeaderColor="info" />
        <br />
      </div>
    </HomePageWrapper>
  )
}

export default withStyles(styles)(OTAMessages)
